import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router'; 
import { AuthContext } from "../context/AuthContext.tsx";

const ProtectedRoute: React.FC = () => {
  const auth = useContext(AuthContext);
  return auth?.isAuth ? <Outlet /> : <Navigate to="/signin" replace />;
};

export default ProtectedRoute;
